import { constantTypes } from "../../src/utils/constants/constant";
import CryptoJS from "crypto-js";
import { BASE_URL } from "../services/path";

export const alphaInput = (event) => {
  if (event) {
    const char = String.fromCharCode(event.which);
    if (!/^[a-zA-Z ]+$/.test(char)) {
      event.preventDefault();
    }
  }
};

export const floatInput = (event) => {
  if (event) {
    const char = String.fromCharCode(event.which);
    if (!/^\d*(\.\d{0,2})?$/.test(char)) {
      event.preventDefault();
    }
  }
};
export const removeMultiSpace = (e) => {
  if (e) {
    e.target.value = e.target.value.replace(/\s{2,}/g, " ");
  }
};

export const integerInput = (event) => {
  if (event) {
    const char = String.fromCharCode(event.which);
    if (!/[0-9]/.test(char)) {
      event.preventDefault();
    }
  }
};

export const whiteSpaceCheck = (value, message) => {
  if (value?.length > 0 && !!value.trim() === false) {
    return message ?? "White spaces not allowed.";
  }
};
export const matchesNewPassword = (
  newPassword,
  confirmNewPassword,
  message
) => {
  if (newPassword != confirmNewPassword) {
    return message;
  }
};

export const encryptData = (data) => {
  if (data) {
    return CryptoJS.AES.encrypt(data, "Egnoto-mern-crm").toString();
  }
};

export const decryptData = (cipherText) => {
  if (cipherText !== undefined) {
    const bytes = CryptoJS.AES.decrypt(cipherText, "Egnoto-mern-crm");
    return bytes.toString(CryptoJS.enc.Utf8);
  }
};

export const formatMonthYearDate = (date) => {
  const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-based
  const day = String(date.getDate()).padStart(2, "0");
  return `${month}/${day}`;
};

export const checkEmailsAndMode = (email1, email2, mode) => {
  return email1 === email2 && mode === "edit";
};

export function formatDate(isoDateString) {
  const date = new Date(isoDateString);
  const day = String(date.getUTCDate()).padStart(2, "0");
  const month = String(date.getUTCMonth() + 1).padStart(2, "0");
  const year = date.getUTCFullYear();

  return `${day}/${month}/${year}`;
}

export const cleanSearchTerm = (term) => {
  const cleaned = term.trim().replace(/\s+/g, " ");
  return cleaned.length > 0 ? cleaned : null;
};

export const getCommaSeparatedLowerCaseNames = (sidebarData, excludeNames) => {
  const filteredArray = sidebarData?.filter(
    (item) => !excludeNames.includes(item?.name)
  );

  const lowerCaseNames = filteredArray?.map(
    (item) => `"${item?.name?.toLowerCase()}"`
  );

  return lowerCaseNames.join(", ");
};

export function capitalizeFirstLetter(str) {
  if (!str) return str;
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
}

export const matchPathName = (href) => {
  return constantTypes.sidebarData.find((item) => item.href === href);
};

export const textTruncateMore = (string, length) => {
  if (string?.length > length) return string.substring(0, length) + "...";
  else return string;
};

export const signupPayload = (
  data,
  dateOfBirth,
  selectedOption,
  profileFile
) => {
  const formData = new FormData();
  console.log("DATA", data);
  // Append image file
  if (profileFile) {
    formData.append("image", profileFile);
  }

  // Append basic user details
  formData.append("firstName", data?.firstName || "");
  formData.append("lastName", data?.lastName || "");
  formData.append("email", data?.email || "");
  formData.append("mobile", data?.mobile || "");
  formData.append("dob", dateOfBirth || "");
  formData.append("placeOfBirth", data?.placeOfBirth || "");
  formData.append("referencePerson", data?.referencePerson || "");
  formData.append("religion", data?.religion || "");
  formData.append("gotra", data?.gotra || "");
  formData.append("villageName", data?.villageName || "");
  formData.append("gender", data?.gender || "");
  formData.append("paymentType", data?.paymentType || "");
  if (data?.paymentType == "online") {
    formData.append("paymentAppType", data?.paymentMethod || "");
    formData.append("paymentScreenshot", data?.screenshot || "");
  }

  formData.append("membershipType", selectedOption);

  // Append current address
  const currentAddress = {
    line1: data?.CurrentAddressLineOne || "",
    line2: data?.CurrentAddressLineTwo || "",
    district: data?.currentDistrict || "",
    city: data?.currentCity || "",
    state: data?.currentState || "",
    country: data?.currentCountry || "",
    landmark: data?.currentLandMark || "",
    pinCode: data?.currentPinCode || "",
  };

  formData.append("currentAddress", JSON.stringify(currentAddress));
  // formData.append("currentAddress[line1]", data?.CurrentAddressLineOne || "");
  // formData.append("currentAddress[line2]", data?.CurrentAddressLineTwo || "");
  // formData.append("currentAddress[district]", data?.currentDistrict || "");
  // formData.append("currentAddress[city]", data?.currentCity || "");
  // formData.append("currentAddress[state]", data?.currentState || "");
  // formData.append("currentAddress[country]", data?.currentCountry || "");
  // formData.append("currentAddress[landmark]", data?.currentLandMark || "");
  // formData.append("currentAddress[pinCode]", data?.currentPinCode || "");

  // Append village address

  const villageAddress = {
    line1: data?.villageAddressLineOne || "",
    line2: data?.villageAddressLineTwo || "",
    district: data?.villageDistrict || "",
    city: data?.villageCity || "",
    state: data?.villageState || "",
    country: data?.villageCountry || "",
    landmark: data?.villageLandMark || "",
    pinCode: data?.villagePinCode || "",
  };

  formData.append("villageAddress", JSON.stringify(villageAddress));
  // formData.append("villageAddress[line1]", data?.villageAddressLineOne || "");
  // formData.append("villageAddress[line2]", data?.villageAddressLineTwo || "");
  // formData.append("villageAddress[district]", data?.villageDistrict || "");
  // formData.append("villageAddress[city]", data?.villageCity || "");
  // formData.append("villageAddress[state]", data?.villageState || "");
  // formData.append("villageAddress[country]", data?.villageCountry || "");
  // formData.append("villageAddress[landmark]", data?.villageLandMark || "");
  // formData.append("villageAddress[pinCode]", data?.villagePinCode || "");

  // Append office information

  const officeAddress = {
    name: data?.officeName || "",
    occupation: data?.officeOccupationName || "",
    designation: data?.officeDesignationName || "",
    department: data?.officeDepartmentName || "",
    line1: data?.officeAddressLineO || "",
    line2: data?.officeAddressLineOne || "",
    phoneNumber: data?.officePhone || "",
    telPhoneNumber: data?.officeTelNumber || "",
    websiteLink: data?.officeWebsiteLink || "",
  };

  formData.append("officeInformation", JSON.stringify(officeAddress));

  // formData.append("officeInformation[name]", data?.officeName || "");
  // formData.append(
  //   "officeInformation[occupation]",
  //   data?.officeOccupationName || ""
  // );
  // formData.append(
  //   "officeInformation[designation]",
  //   data?.officeDesignationName || ""
  // );
  // formData.append(
  //   "officeInformation[department]",
  //   data?.officeDepartmentName || ""
  // );
  // formData.append("officeInformation[line1]", data?.officeAddressLineO || "");
  // formData.append("officeInformation[line2]", data?.officeAddressLineOne || "");
  // formData.append("officeInformation[phoneNumber]", data?.officePhone || "");
  // formData.append(
  //   "officeInformation[telPhoneNumber]",
  //   data?.officeTelNumber || ""
  // );
  // formData.append(
  //   "officeInformation[websiteLink]",
  //   data?.officeWebsiteLink || ""
  // );

  // Append family information
  if (Array.isArray(data?.familyInformation)) {
    formData.append(
      "familyInformation",
      JSON.stringify(data?.familyInformation)
    );
  }

  return formData;
};

export const bioDataPayload = (
  data,
  dateOfBirth,
  profileFile,
  eventImages,
  deleteMultipleImages
) => {
  const formData = new FormData();
  console.log("DATA", data);
  // Append image file
  if (profileFile) {
    formData.append("image", profileFile);
  }

  // Append basic user details
  formData.append("firstName", data?.firstName || "");
  formData.append("lastName", data?.lastName || "");
  formData.append("rashi", data?.rashi || "");
  formData.append("religion", "Hindu");
  formData.append("gotra", data?.gotra || "");
  formData.append("height", data?.height || "");
  formData.append("weight", data?.weight || "");
  formData.append("personality", data?.personality || "");
  formData.append("diet", data?.diet || "");
  formData.append("gender", data?.gender || "");
  formData.append(
    "deleteMultipleImage",
    JSON.stringify(
      deleteMultipleImages.map((item) => item.split(`${BASE_URL}/uploads/`)[1])
    )
  );

  const birthDetails = {
    dob: dateOfBirth || "",
    timeOfBirth: data?.timeOfBirth || "",
    day: data?.day || "",
    placeOfBirth: data?.placeOfBirth || "",
  };

  formData.append("birthDetails", JSON.stringify(birthDetails));

  const education = {
    degree: data?.degree || "",
    collegeName: data?.collegeName || "",
    yearOfPassing: data?.yearOfPassing || "",
  };

  formData.append("education", JSON.stringify(education));

  const professionalDetails = {
    officeName: data?.officeName || "",
    departmentName: data?.officeDepartmentName || "",
    officeDesignation: data?.officeDesignationName || "",
    officeAddress: data?.officeAddress || "",
    officePhoneNumber: data?.officePhoneNumber || "",
    tel: data?.officeNumber || "",
    description: data?.description,
    maritalStatus: data?.maritalStatus,
  };

  formData.append("professionalDetails", JSON.stringify(professionalDetails));

  const officeInformation = {
    designation: data?.officeDesignationName || "",
    officeNumber: data?.officeNumber || "",
    annualIncome: data?.annualIncome,
  };
  formData.append("officeInformation", JSON.stringify(officeInformation));

  const contactPersonInformation = {
    name: data?.contactPersonName || "",
    mobileNumber: data?.contactPersonMobile || "",
    email: data?.contactPersonEmail || "",
  };

  formData.append(
    "contactPersonInformation",
    JSON.stringify(contactPersonInformation)
  );

  // Append current address
  const currentAddress = {
    line1: data?.CurrentAddressLineOne || "",
    line2: data?.CurrentAddressLineTwo || "",
    district: data?.currentDistrict || "",
    city: data?.currentCity || "",
    state: data?.currentState || "",
    country: data?.currentCountry || "",
    landmark: data?.currentLandMark || "",
    pinCode: data?.currentPinCode || "",
  };

  formData.append("address", JSON.stringify(currentAddress));

  // Append village address
  const villageAddress = {
    line1: data?.villageAddressLineOne || "",
    line2: data?.villageAddressLineTwo || "",
    district: data?.villageDistrict || "",
    city: data?.villageCity || "",
    state: data?.villageState || "",
    country: data?.villageCountry || "",
    landmark: data?.villageLandMark || "",
    pinCode: data?.villagePinCode || "",
  };

  formData.append("villageAddress", JSON.stringify(villageAddress));

  // Append family information
  if (Array.isArray(data?.familyInformation)) {
    formData.append(
      "familyInformation",
      JSON.stringify(data?.familyInformation)
    );
  }

  // Append family information
  if (Array.isArray(eventImages)) {
    Array.from(eventImages).forEach((item, index) => {
      typeof item === "object" && formData.append(`multipleImage`, item);
    });
  }

  return formData;
};
